var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.82,
    height: 77.82,
    viewBox: "0 0 77.82 77.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(0.01 0.01)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1105",
    "data-name": "Ellipse 1105",
    cx: 38.91,
    cy: 38.91,
    r: 38.91,
    transform: "translate(-0.01 -0.01)",
    fill: "#77e041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M198.233,153.7a39.056,39.056,0,0,1-27.82,27.82l-25.447-25.447a4.921,4.921,0,0,1-1.486-3.528V128.71a4.943,4.943,0,0,1,4.935-4.94h17.849a4.929,4.929,0,0,1,3.529,1.488Z",
    transform: "translate(-121.681 -104.967)",
    fill: "#6bca3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3405",
    "data-name": "Group 3405",
    transform: "translate(21.799 18.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M171.122,127.832a4.947,4.947,0,0,0-4.857-4.052H148.415a4.942,4.942,0,0,0-4.935,4.94v23.833a4.946,4.946,0,0,0,4.047,4.857V135.136a7.313,7.313,0,0,1,7.3-7.3Z",
    transform: "translate(-143.48 -123.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M208.961,166.44H190.983a4.872,4.872,0,0,0-4.873,4.873v23.962a4.872,4.872,0,0,0,4.873,4.873h17.979a4.872,4.872,0,0,0,4.873-4.873V171.313A4.872,4.872,0,0,0,208.961,166.44Z",
    transform: "translate(-179.631 -159.956)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3406",
    "data-name": "Group 3406",
    transform: "translate(21.799 18.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M157.341,127.832V123.78h-8.926a4.942,4.942,0,0,0-4.935,4.94v23.833a4.946,4.946,0,0,0,4.047,4.857V135.136a7.313,7.313,0,0,1,7.3-7.3Z",
    transform: "translate(-143.48 -123.78)",
    fill: "#e6ecff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M190.983,166.44a4.872,4.872,0,0,0-4.873,4.873v23.962a4.872,4.872,0,0,0,4.873,4.873h8.988V166.44Z",
    transform: "translate(-179.631 -159.956)",
    fill: "#e6ecff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.dc27c552b12f01d7963704b48a19d1d3.svg";
export { ForwardRef as ReactComponent };